const lowlightLanguageMappings = {
  "ts": "typescript",
  "js": "javascript",
  "py": "python",
  "py3": "python",
  "c#": "csharp",
  "c++": "cpp",
  "node": "javascript"
};
export {
  lowlightLanguageMappings
};
//# sourceMappingURL=constants.js.map
